<template>
    <div>
        <limitless-page-header
            :loading="!initialized"
            title="Sales CRM"
            :sub-title="(this.company_name || '')"
        >
            <template #header-elements>
                <limitless-page-header-button v-if="company && company.id>0" @click.prevent="openHistoryModal" icon="icon-envelop3">Historik</limitless-page-header-button>
                <limitless-page-header-button v-if="$route.query.from" :url="$route.query.from" icon="icon-arrow-left52">Tillbaka</limitless-page-header-button>
                <limitless-page-header-button v-else :route="{ name: 'crm.companies' }" icon="icon-arrow-left52">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <crm-menu></crm-menu>

        <div class="content">
            <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
            <div v-else-if="company" class="card">
                <div class="card-body">
                    <form @submit.prevent="saveData">
                        <ValidationObserver ref="companyform">
                            <div class="row">
                                <div class="col-xl-4">
                                    <ValidationProvider vid="name" name="Namn" rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Namn <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="company.name" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <ValidationProvider vid="org_no" name="Org. nummer" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Org. nummer</label>
                                            <input type="text" class="form-control" v-model="company.org_no" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <ValidationProvider vid="address_street_1" name="Adressrad 1" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Adressrad 1</label>
                                            <input type="text" class="form-control" v-model="company.address_street_1" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <ValidationProvider vid="address_street_2" name="Adressrad 2" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Adressrad 2</label>
                                            <input type="text" class="form-control" v-model="company.address_street_2" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <div class="row">
                                        <div class="col-4">
                                            <ValidationProvider vid="address_postalcode" name="Postnummer" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Postnummer</label>
                                                    <input type="text" class="form-control" v-model="company.address_postalcode" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-8">
                                            <ValidationProvider vid="address_city" name="Ort" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Ort</label>
                                                    <input type="text" class="form-control" v-model="company.address_city" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <ValidationProvider vid="address_country" name="Land" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Land</label>
                                            <input type="text" class="form-control" v-model="company.address_country" v-bind:class="{ 'border-danger':errors[0] }">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-4">
                                    <select-with-validation
                                        vid="tags"
                                        label="Taggar"
                                        component="sales-crm-strings-filter"
                                        v-model="company.tags"
                                        multiple
                                        :type="4"
                                        taggable
                                    ></select-with-validation>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="suffix" name="Tillägg" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Tillägg</label>
                                                    <input type="text" class="form-control" v-model="company.suffix" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="industry" name="Branch / Verksamhet" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Branch / Verksamhet</label>
                                                    <input type="text" class="form-control" v-model="company.industry" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <ValidationProvider vid="website" name="Webbadress" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Webbadress</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="company.website" v-bind:class="{ 'border-danger':errors[0] }">
                                                <div class="input-group-append">
                                                    <a :href="company.website" target="_blank" class="btn btn-light btn-icon"><i class="icon-sphere"></i></a>
                                                </div>
                                            </div>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="phone" name="Telefon" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Telefon</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" v-model="company.phone" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <div class="input-group-append">
                                                            <a :href="'tel:' + company.phone" class="btn btn-light btn-icon"><i class="icon-phone2"></i></a>
                                                        </div>
                                                    </div>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="email" name="E-post" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>E-post</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" v-model="company.email" v-bind:class="{ 'border-danger':errors[0] }">
                                                        <div class="input-group-append">
                                                            <a :href="'mailto:' + company.email" class="btn btn-light btn-icon"><i class="icon-envelope"></i></a>
                                                        </div>
                                                    </div>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <ValidationProvider vid="notes" name="Noteringar" rules="" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Noteringar</label>
                                            <textarea rows="5" style="min-height: 120px;" type="text" class="form-control" v-model="company.notes" v-bind:class="{ 'border-danger':errors[0] }"></textarea>
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-xl-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <select-with-validation
                                                component="sales-crm-users-filter"
                                                label="Säljare"
                                                vid="sellers_ids"
                                                rules="required"
                                                v-model="company.sellers_ids"
                                                placeholder="Välj säljare"
                                                :reduce="opt => opt.id"
                                                multiple
                                            ></select-with-validation>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="gifts" name="Antal gåvor" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Antal gåvor</label>
                                                    <input type="text" class="form-control" v-model="company.gifts" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="summer_gift" name="Sommargåva" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Sommargåva</label>
                                                    <v-select
                                                        v-model="company.summer_gift"
                                                        :options="select_summer_gifts"
                                                        placeholder="Välj..."
                                                        :reduce="opt => opt.id"
                                                        label="string"
                                                    ></v-select>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="budget" name="Budget" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Budget</label>
                                                    <input type="text" class="form-control" v-model="company.budget" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="price_offer" name="Pris enl. offert" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Pris enl. offert</label>
                                                    <input type="text" class="form-control" v-model="company.price_offer" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="decision" name="Beslut" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Tar beslut</label>
                                                    <input type="text" class="form-control" v-model="company.decision" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="delivery_date" name="Leveransdatum" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Planerat Leveransdatum</label>
                                                    <input type="text" class="form-control" v-model="company.delivery_date" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <ValidationProvider vid="testcard" name="Testkort" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Testkort</label>
                                                    <input type="text" class="form-control" v-model="company.testcard" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-6">
                                            <ValidationProvider vid="envelope" name="Kuvert" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <label>Val av kuvert</label>
                                                    <input type="text" class="form-control" v-model="company.envelope" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ValidationObserver>
                    </form>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="text-muted">Senast uppdaterad {{ formatDateTime(company.updated_at) }}<span v-if="company.updated_by"> av {{ company.updated_by.name }}</span></div>
                        </div>
                        <div class="col-md-6 text-right">
                            <limitless-button ref="btnsavecompany" type="button" @click="saveData" :busy="company_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <i class="text-danger font-italic">Företaget hittades inte...</i>
            </div>

            <div v-if="company && company.id > 0">
                <ul class="nav nav-tabs nav-tabs-highlight mb-0">
                    <li class="nav-item"><a href="#highlighted-tab1" class="nav-link active" data-toggle="tab">Att göra</a></li>
                    <li class="nav-item"><a href="#highlighted-tab2" class="nav-link" data-toggle="tab">Kontakter</a></li>
                    <li class="nav-item"><a href="#highlighted-tab3" class="nav-link" data-toggle="tab">Kopplade kunder</a></li>
                    <li class="nav-item"><a href="#highlighted-tab4" class="nav-link" data-toggle="tab">Ordrar</a></li>
                </ul>

                <div class="tab-content">
                    <rednax-datatable
                        ref="todotable"
                        class="tab-pane show active border-top-0 rounded-top-0"
                        id="highlighted-tab1"
                        key="highlighted-tab1"
                        :url="'/vue/sales/crm/todo'"
                        :columns="todos_columns"
                        :filter="todos_filter"
                        @rowclick="openTodoModal"
                    >
                        <div class="row">
                            <div class="col-lg-3">
                                <input type="text" v-model="todos_filter.search" class="form-control">
                            </div>
                            <div class="col-lg-3">
                            </div>
                            <div class="col-lg-6 text-right">
                                <button type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="openTodoModal({id: 0})"><b><i class="icon-plus3"></i></b>Skapa ny</button>
                            </div>
                        </div>
                    </rednax-datatable>
                    <rednax-datatable
                        ref="contacttable"
                        class="tab-pane border-top-0 rounded-top-0"
                        id="highlighted-tab2"
                        key="highlighted-tab2"
                        :url="'/vue/sales/crm/contact'"
                        :columns="contacts_columns"
                        :filter="contacts_filter"
                        @rowclick="openContactModal"
                        sort-by="is_important"
                        sort-order="desc"
                    >
                        <div class="row">
                            <div class="col-lg-3">
                                <input type="text" v-model="contacts_filter.search" class="form-control">
                            </div>
                            <div class="col-lg-3">
                            </div>
                            <div class="col-lg-6 text-right">
                                <button type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="openContactModal({id: 0})"><b><i class="icon-plus3"></i></b>Skapa ny</button>
                            </div>
                        </div>
                    </rednax-datatable>
                    <rednax-datatable
                        ref="customertable"
                        class="tab-pane border-top-0 rounded-top-0"
                        id="highlighted-tab3"
                        key="highlighted-tab3"
                        :url="'/vue/sales/crm/company/' + id + '/customers'"
                        :columns="customers_columns"
                        :filter="customers_filter"
                        @rowclick="gotToCustomer"
                        sort-by="CustomerID"
                        sort-order="desc"
                    >
                        <div class="row">
                            <div class="col-lg-3">
                                <input type="text" v-model="customers_filter.search" class="form-control">
                            </div>
                            <div class="col-lg-6">
                            </div>
                            <div class="col-lg-3 text-right">
                                <button type="button" class="btn btn-primary btn-labeled btn-labeled-left" @click="openConnectedCustomersModal"><b><i class="icon-link"></i></b>Koppla kunder</button>
                            </div>
                        </div>
                    </rednax-datatable>
                    <rednax-datatable
                        ref="orderstable"
                        class="tab-pane border-top-0 rounded-top-0"
                        id="highlighted-tab4"
                        key="highlighted-tab4"
                        :url="'/vue/sales/crm/company/' + id + '/orders'"
                        :columns="orders_columns"
                        :filter="orders_filter"
                        @rowclick="gotToOrder"
                        sort-by="OrderID"
                        sort-order="desc"
                    >
                        <div class="row">
                            <div class="col-lg-3">
                                <input type="text" v-model="orders_filter.search" class="form-control">
                            </div>
                        </div>
                    </rednax-datatable>
                </div>
            </div>
        </div>

        <div id="modal_todo" class="modal fade" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="todo">
                    <div class="modal-header">
                        <h5 v-if="todo.id>0" class="modal-title">{{ todo.subject }}</h5>
                        <h5 v-else class="modal-title">Ny att göra</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <todo-form v-model="todo" :strings="strings" :companies="companies" :users="users" ref="todoform"></todo-form>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeletetodo" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteTodo" :busy="todo_busy">RADERA ATT GÖRA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsavetodo" type="button" @click="saveTodo" :busy="todo_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                    <div class="modal-body border-top" v-if="company">
                        <history-form v-if="show_history_form_id === 0" :users="users" :strings="strings" :company="company" :history-id="0"  @saved="historySaved(-1, $event)"></history-form>
                        <button v-else class="btn btn-light btn-block" @click="showHistoryForm(0)"><i class="icon-plus3 mr-2"></i> Lägg till ny historik</button>

                        <div v-for="(h_item, h_index) in company.history" :key="'h-' + h_index" class="mt-3">
                            <history-form v-if="show_history_form_id === h_item.id" :users="users" :strings="strings" :company="company" :history-id="h_item.id" @saved="historySaved(h_index, $event)"></history-form>
                            <div v-else class="card mt-3">
                                <div class="card-header py-2 border-bottom header-elements-inline" style="background-color: #ecf6fe;">
                                    <h5 class="font-weight-semibold mb-0">
                                        <span v-if="h_item.type">{{ h_item.type.string }}: </span>{{ h_item.subject }}
                                    </h5>
                                    <div class="header-elements">
                                        <div class="font-weight-semibold text-right no-wrap">{{ h_item.date_time.substr(0, 16) }}</div>
                                    </div>
                                </div>
                                <div class="card-header bg-white d-flex flex-row py-2">
                                    <div class="flex-grow-1">
                                        <div v-if="h_item.contact">
                                            <span class="font-weight-semibold no-wrap">{{ h_item.contact.name }}</span> <span v-if="h_item.contact.work_title">({{ h_item.contact.work_title }})</span>
                                            <div v-if="h_item.contact.email">
                                                <a :href="'mailto:' + h_item.contact.email" >{{ h_item.contact.email }}</a>
                                            </div>
                                            <div v-if="h_item.contact.phone || h_item.contact.mobile_phone">
                                                <a v-if="h_item.contact.phone" :href="'tel:' + h_item.contact.phone" >{{ h_item.contact.phone }}</a>
                                                <span v-if="h_item.contact.phone && h_item.contact.mobile_phone"> / </span>
                                                <a v-if="h_item.contact.mobile_phone" :href="'tel:' + h_item.contact.mobile_phone" >{{ h_item.contact.mobile_phone }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-right">
                                            <div v-if="h_item.seller" class="text-muted no-wrap">{{ h_item.seller.name }}</div>
                                            <a href="" @click.prevent="showHistoryForm(h_item.id)">Redigera</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-html="h_item.html">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Att göra</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->

        <div id="modal_contact" class="modal fade" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-if="contact">
                    <div class="modal-header">
                        <h5 v-if="contact.id>0" class="modal-title">{{ contact.name }}</h5>
                        <h5 v-else class="modal-title">Ny kontakt</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="saveContact">
                            <contact-form v-model="contact" :strings="strings" :companies="companies" ref="contactform"></contact-form>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="mr-auto">
                            <limitless-button ref="btndeletecontact" type="button" btn-class="btn-danger" icon="icon-cross2" @click="deleteContact" :busy="contact_busy">RADERA</limitless-button>
                        </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                        <limitless-button ref="btnsavecontact" type="button" @click="saveContact" :busy="contact_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">
                        <h5 class="modal-title">Kontakt</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <i style="color:red;">Kunde ej ladda data</i>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->

        <div id="modal_history" class="modal fade" tabindex="-1" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Historik</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" v-if="company">
                        <history-form v-if="show_history_form_id === 0" :users="users" :strings="strings" :company="company" :history-id="0"  @saved="historySaved(-1, $event)"></history-form>
                        <button v-else class="btn btn-light btn-block" @click="showHistoryForm(0)"><i class="icon-plus3 mr-2"></i> Lägg till ny historik</button>

                        <div v-for="(h_item, h_index) in company.history" :key="'h-' + h_index" class="mt-3">
                            <history-form v-if="show_history_form_id === h_item.id" :users="users" :strings="strings" :company="company" :history-id="h_item.id" @saved="historySaved(h_index, $event)"></history-form>
                            <div v-else class="card mt-3">
                                <div class="card-header py-2 border-bottom header-elements-inline" style="background-color: #ecf6fe;">
                                    <h5 class="font-weight-semibold mb-0">
                                        <span v-if="h_item.type">{{ h_item.type.string }}: </span>{{ h_item.subject }}
                                    </h5>
                                    <div class="header-elements">
                                        <div class="font-weight-semibold text-right no-wrap">{{ h_item.date_time.substr(0, 16) }}</div>
                                    </div>
                                </div>
                                <div class="card-header bg-white d-flex flex-row py-2">
                                    <div class="flex-grow-1">
                                        <div v-if="h_item.contact">
                                            <span class="font-weight-semibold no-wrap">{{ h_item.contact.name }}</span> <span v-if="h_item.contact.work_title">({{ h_item.contact.work_title }})</span>
                                            <div v-if="h_item.contact.email">
                                                <a :href="'mailto:' + h_item.contact.email" >{{ h_item.contact.email }}</a>
                                            </div>
                                            <div v-if="h_item.contact.phone || h_item.contact.mobile_phone">
                                                <a v-if="h_item.contact.phone" :href="'tel:' + h_item.contact.phone" >{{ h_item.contact.phone }}</a>
                                                <span v-if="h_item.contact.phone && h_item.contact.mobile_phone"> / </span>
                                                <a v-if="h_item.contact.mobile_phone" :href="'tel:' + h_item.contact.mobile_phone" >{{ h_item.contact.mobile_phone }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-right">
                                            <div v-if="h_item.seller" class="text-muted no-wrap">{{ h_item.seller.name }}</div>
                                            <a href="" @click.prevent="showHistoryForm(h_item.id)">Redigera</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-html="h_item.html">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->

        <div id="modal_connected_customers" class="modal fade" tabindex="-1" data-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Koppla kunder</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div v-if="company" class="modal-body">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Kundnr</th>
                                    <th>Kund</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(customer, c_index) in company.customers" :key="'customer-' + customer.CustomerID">
                                    <th>{{ customer.CustomerID }}</th>
                                    <th>{{ customer.CompanyName }}</th>
                                    <th class="text-right">
                                        <button type="button" class="btn btn-sm btn-danger" @click="removeCustomer(c_index)"><i class="icon-trash"></i></button>
                                    </th>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="3">
                                        <v-select
                                            :options="customer_options"
                                            :filterable="false"
                                            @search="fetchCustomerOptions"
                                            @option:selected="addConnectedCustomer"
                                            v-model="select_connected_customer"
                                            placeholder="-- Sök för att lägga till kund --"
                                            :get-option-label="(opt) => opt.CustomerID + ' - ' + opt.CompanyName"
                                        >
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    Hittade inga resultat på <em>{{ search }}</em>.
                                                </template>
                                                <em style="opacity: 0.5;" v-else>Sök på kunder</em>
                                            </template>
                                        </v-select>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Avbryt</button>
                        <limitless-button ref="btnsavecustomers" type="button" @click="saveData" :busy="company_busy" icon="icon-floppy-disk">SPARA</limitless-button>
                    </div>
                </div>
            </div>
        </div> <!-- /modal -->
    </div>
</template>

<script>
import vSelect from 'vue-select';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import HistoryForm from '@app/pages/sales_crm/partials/HistoryForm';
import TodoForm from '@app/pages/sales_crm/partials/TodoForm';
import ContactForm from '@app/pages/sales_crm/partials/ContactForm';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import CrmMenu from '@app/pages/sales_crm/partials/CrmMenu.vue';

export default {
    name: 'SalesCrmCompany',
    components: {
        CrmMenu,
        SelectWithValidation,
        HistoryForm,
        LimitlessPageHeaderButton,
        LimitlessPageHeader,
        vSelect,
        RednaxDatatable,
        ContactForm,
        TodoForm,
        LimitlessButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        initialized: false,
        loading: true,
        company_busy: false,
        company: null,
        show_history_form_id: -1,
        customer_options: [],
        select_connected_customer: null,
        customers_filter: {
            search: '',
        },
        orders_filter: {
            search: '',
        },
        orders_columns: [
            {
                header: '#',
                data: 'OrderID',
                sortable: true,
                render(row) {
                    return '<div><a href="/cardorders/' + row.OrderID + '">' + row.OrderID + '</a></div>';
                },
            },
            {
                header: 'Datum',
                data: 'CreatedTS',
                sortable: true,
                render(row) {
                    return '<nobr>' + row.CreatedTS.substring(0, 10) + '</nobr>';
                },
            },
            {
                header: 'Kundgrupp',
                data: 'CustomerGroupName',
                sortable: true,
            },
            {
                header: 'Kund',
                data: 'name',
                sortable: true,
                render(row) {
                    return row.CompanyName + (row.EndCustomer ? ' / ' + row.EndCustomer : '');
                },
            },
            {
                header: 'Epost',
                data: 'CustomerContactMail',
                sortable: true,
            },
            {
                header: 'Kund Ordernr',
                data: 'CustomerRefNo',
                sortable: true,
            },
            {
                header: 'Leverans',
                data: 'DelivCompany',
                sortable: true,
            },
            {
                header: 'Antal kort',
                data: 'CardAmountTotal',
                sortable: true,
                align_right: true,
                render(row) {
                    return row.CardAmountTotal + ' st';
                },
            },
            {
                header: 'Antal Aktiverade',
                data: 'CardAmountActivated',
                sortable: true,
                align_right: true,
                render(row) {
                    return row.CardAmountActivated + ' st';
                },
            },
            {
                header: 'Källa',
                data: 'CreatedSource',
                sortable: false,
                render(row) {
                    if (row.CreatedSource === 'intranet') {
                        return 'Intranät';
                    }
                    if (row.CreatedSource === 'SUPEKORT_SE_TWILL_V3' || row.CreatedSource === 'SUPEKORT_SE_STATAMIC_V2' || row.CreatedSource === 'SUPEKORT_SE_STATAMIC' || row.CreatedSource === 'supekort.se') {
                        return 'supekort.se';
                    }
                    if (row.CreatedSource === 'Custom Order webAPI' || row.CreatedSource === 'Interstellar API') {
                        return 'Kundportal/API';
                    }
                    return row.CreatedSource;
                },
            },
            {
                header: 'Status',
                data: 'StatusID',
                sortable: true,
                render(row) {
                    return row.Status;
                },
            },
        ],
        contact_busy: false,
        contact: null,
        contacts_filter: {
            search: '',
            company_id: 0,
        },
        contacts_columns: [
            {
                header: '<i class="icon-star-full2"></i>',
                data: 'is_important',
                sortable: true,
                render(row) {
                    return (row.is_important ? '<i class="icon-star-full2 text-orange-400"></i>' : '');
                },
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Befattning',
                data: 'work_title',
                sortable: true,
            },
            {
                header: 'Företag',
                data: 'company_name',
                sortable: true,
            },
            {
                header: 'E-post',
                data: 'email',
                sortable: true,
            },
            {
                header: 'Tel. nr',
                data: 'phone',
                sortable: true,
            },
            {
                header: 'Mob. nr',
                data: 'mobile_phone',
                sortable: true,
            },
        ],
        todo_busy: false,
        todo: null,
        todos_filter: {
            search: '',
            company_id: 0,
        },
        todos_columns: [
            {
                header: 'Prioritet',
                data: 'priority',
                sortable: true,
                render(row) {
                    if (row.priority === 1) {
                        return '<span class="badge badge-danger">Hög</span>';
                    } if (row.priority === 2) {
                        return '<span class="badge bg-purple-400">Medel</span>';
                    }
                    return '<span class="badge badge-primary">Låg</span>';
                },
            },
            {
                header: 'Ämne',
                data: 'subject',
                sortable: true,
            },
            {
                header: 'Medarbetare',
                data: 'user_name',
                sortable: true,
            },
            {
                header: 'Påbörjas',
                data: 'start_ts',
                sortable: true,
            },
            {
                header: 'Klar senast',
                data: 'end_ts',
                sortable: true,
            },
        ],
        strings: {},
        users: [],
    }),
    created() {
        this.todos_filter.company_id = this.id;
        this.contacts_filter.company_id = this.id;
        apiClient.get('/vue/sales/crm/select_users')
            .then((response) => {
                this.users = response.data;
            });
        apiClient.get('/vue/sales/crm/select_strings')
            .then((response) => {
                this.strings = response.data;
            });
        // BackendRepository.getSalesCrmUsers().then((data) => {
        //     this.users = data;
        // });
        // BackendRepository.getSalesCrmStrings().then((data) => {
        //     this.strings = data;
        // });
        this.getData();
    },
    methods: {
        formatDateTime,
        getData() {
            this.company_busy = true;
            apiClient.get(`/vue/sales/crm/company/${this.id}`)
                .then((response) => {
                    this.company = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.company_busy = false;
                    this.loading = false;
                });
        },
        async saveData() {
            const isValid = await this.$refs.companyform.validate();
            if (isValid) {
                this.company_busy = true;
                await apiClient.post(`/vue/sales/crm/company/${this.company.id}`, this.company)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== response.data.id) {
                            this.$router.push({ name: 'crm.company', params: { id: response.data.id } });
                        }
                        this.company = response.data;
                        this.todos_filter.company_id = response.data.id;
                        this.contacts_filter.company_id = response.data.id;
                        this.$refs.btnsavecompany.triggerSaved();
                        $('#modal_connected_customers').modal('hide');
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.companyform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecompany.triggerFailed();
                    })
                    .finally(() => {
                        this.company_busy = false;
                    });
            } else {
                this.$refs.btnsavecompany.triggerFailed();
            }
        },
        openTodoModal(todo) {
            this.todo_busy = true;
            apiClient.get(`/vue/sales/crm/todo/${todo.id}`)
                .then((response) => {
                    this.todo = response.data;
                    this.todo.company_id = this.company.id;
                    // eslint-disable-next-line no-undef
                    $('#modal_todo').modal('show');
                })
                .finally(() => {
                    this.todo_busy = false;
                });
        },
        async saveTodo() {
            const isValid = await this.$refs.todoform.validate();
            if (isValid) {
                this.todo_busy = true;
                await apiClient.post(`/vue/sales/crm/todo/${this.todo.id}`, this.todo)
                    .then((response) => {
                        this.todo = response.data;
                        this.$refs.btnsavetodo.triggerSaved();
                        this.$refs.todotable.reload();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.todoform.setErrors(parsederror);
                        }
                        this.$refs.btnsavetodo.triggerFailed();
                    })
                    .finally(() => {
                        this.todo_busy = false;
                    });
            } else {
                this.$refs.btnsavetodo.triggerFailed();
            }
        },
        async deleteTodo() {
            // eslint-disable-next-line no-undef
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    this.todo_busy = true;
                    await apiClient.delete(`/vue/sales/crm/todo/${this.todo.id}`)
                        .then(() => {
                            this.$refs.btndeletetodo.triggerSaved();
                            this.$refs.todotable.reload();
                            // eslint-disable-next-line no-undef
                            $('#modal_todo').modal('hide');
                        })
                        .catch(() => {
                            this.$refs.btndeletetodo.triggerFailed();
                        })
                        .finally(() => {
                            this.todo_busy = false;
                        });
                }
            });
        },
        openContactModal(contact) {
            this.contact_busy = true;
            apiClient.get(`/vue/sales/crm/contact/${contact.id}`)
                .then((response) => {
                    this.contact = response.data;
                    this.contact.company_id = this.company.id;
                    // eslint-disable-next-line no-undef
                    $('#modal_contact').modal('show');
                })
                .finally(() => {
                    this.contact_busy = false;
                });
        },
        async saveContact() {
            const isValid = await this.$refs.contactform.validate();
            if (isValid) {
                this.contact_busy = true;
                await apiClient.post(`/vue/sales/crm/contact/${this.contact.id}`, this.contact)
                    .then((response) => {
                        this.contact = response.data;
                        this.$refs.btnsavecontact.triggerSaved();
                        this.$refs.contacttable.reload();
                        this.getData();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.contactform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecontact.triggerFailed();
                    })
                    .finally(() => {
                        this.contact_busy = false;
                    });
            } else {
                this.$refs.btnsavecontact.triggerFailed();
            }
        },
        async deleteContact() {
            // eslint-disable-next-line no-undef
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    this.contact_busy = true;
                    await apiClient.delete(`/vue/sales/crm/contact/${this.contact.id}`)
                        .then(() => {
                            this.$refs.btndeletecontact.triggerSaved();
                            this.$refs.contacttable.reload();
                            // eslint-disable-next-line no-undef
                            $('#modal_contact').modal('hide');
                        })
                        .catch(() => {
                            this.$refs.btndeletecontact.triggerFailed();
                        })
                        .finally(() => {
                            this.contact_busy = false;
                        });
                }
            });
        },
        openHistoryModal() {
            this.history = null;
            // eslint-disable-next-line no-undef
            $('#modal_history').modal('show');
        },
        showHistoryForm(historyId = 0) {
            this.show_history_form_id = historyId;
        },
        historySaved(index, history) {
            if (index < 0) {
                this.company.history.unshift(history);
            } else {
                this.company.history[index] = history;
            }
            this.show_history_form_id = -1;
        },
        gotToOrder(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/cardorders/' + row.OrderID).focus();
            } else {
                window.location.href = '/cardorders/' + row.OrderID;
            }
        },
        gotToCustomer(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/customers' + row.CustomerID).focus();
            } else {
                window.location.href = '/customers/' + row.CustomerID;
            }
        },
        removeCustomer(idx) {
            const index = this.company.customers_ids.indexOf(this.company.customers[idx]);
            if (index !== -1) {
                this.company.customers_ids.splice(index, 1);
            }
            this.company.customers.splice(idx, 1);
        },
        openConnectedCustomersModal() {
            $('#modal_connected_customers').modal('show');
        },
        addConnectedCustomer(customer) {
            if (customer) {
                this.company.customers.push(customer);
                this.company.customers_ids.push(customer.CustomerID);
                this.customer_options = [];
            }
            this.select_connected_customer = null;
            this.$refs.customertable.reload();
            this.$refs.orderstable.reload();
        },
        fetchCustomerOptions(search) {
            if (search) {
                apiClient.get(`/vue/customers?search=${search}&per_page=10`)
                    .then((response) => {
                        this.customer_options = response.data.data;
                    });
            } else {
                this.customer_options = [];
            }
        },
    },
    computed: {
        company_name() {
            return (this.company && this.company.id > 0 ? this.company.name : 'Ny kund');
        },
        companies() {
            const obj = {};
            if (this.company && this.company.id > 0) {
                obj[this.company.id] = { id: this.company.id, text: this.company.name, sellers: this.company.sellers };
            }
            return obj;
        },
        select_summer_gifts() {
            return this.strings[500] ?? [];
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        customers_columns() {
            return [
                {
                    header: '#',
                    data: 'Kundnr',
                    sortable: true,
                    render(row) {
                        return '<div><a href="/customers/' + row.CustomerID + '">' + row.CustomerID + '</a></div>';
                    },
                },
                {
                    header: 'Namn',
                    data: 'CompanyName',
                    sortable: true,
                },
                {
                    header: 'Org. nr',
                    data: 'OrgNo',
                    sortable: true,
                },
                {
                    header: 'Kundgrupp',
                    data: 'customer_groups',
                    sortable: true,
                },
            ];
        },
    },
};
</script>

<style scoped>

</style>
